import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ISamithi_Members {
samithi_member_id:number,
name?:string,
surname?:string,
father_name?:string,
rev_addrs1:string,
rev_addrs2:string,
rev_addrs3:string,
rev_village:string,
rev_mandal:string,
pincode:string,
vibhag_id:number,
zilla_id:number,
added_occation:string,
nagar_khanda_id:number,
upamandal_id:number,
is_basti_gramam:string,
basti_gramam_id:number,
status:boolean,
created_on:Date,
created_by:number,
modified_on:Date,
modified_by:number
}

interface ISamithi_MembersData {
    list?: Array<ISamithi_Members>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: ISamithi_MembersData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const samithi_membersSlice = createSlice({
    name: "samithi_members",
    initialState,
    reducers: {
        setSamithi_MembersList: (state, _action: PayloadAction<ISamithi_MembersData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetSamithi_MembersToInit: (state) => {
            state = initialState;
        },
        setSamithi_MembersMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setSamithi_MembersList, resetSamithi_MembersToInit, setSamithi_MembersMessage } = samithi_membersSlice.actions;

export default samithi_membersSlice.reducer;

